module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  " + _vm._s(_vm.defaultResourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: ("/" + _vm.basePath)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-sortable",
    attrs: {
      "id": "wid-id-11",
      "data-widget-colorbutton": "false",
      "data-widget-editbutton": "false",
      "data-widget-togglebutton": "false",
      "data-widget-deletebutton": "false",
      "data-widget-fullscreenbutton": "false",
      "data-widget-custombutton": "false",
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "widget-tab-1"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.showTabs) ? _c('li', {
    class: {
      'bg-color-orange': false
    }
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.showTabs) ? _c('li', {
    class: {
      'bg-color-orange': false
    }
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.showTabs) ? _c('li', {
    class: {
      'bg-color-orange': false
    }
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.showTabs) ? _c('li', {
    class: {
      'bg-color-orange': false
    }
  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.showTabs) ? _c('li', {
    class: {
      'bg-color-orange': false
    }
  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.showTabs) ? _c('li', {
    class: {
      'bg-color-orange': false
    }
  }, [_vm._m(7)]) : _vm._e(), _vm._v(" "), (_vm.showTabs) ? _c('li', {
    class: {
      'bg-color-orange': false
    }
  }, [_vm._m(8)]) : _vm._e()]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "tab-content m-b-10 padding-10"
  }, [_c('div', {
    staticClass: "tab-pane active in fade",
    attrs: {
      "id": "hr1"
    }
  }, [_c('form-vehicle-create', {
    ref: "formVehicleCreate",
    attrs: {
      "group": 1,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "pull-right",
    staticStyle: {
      "right": "20px"
    }
  }, [_c('strong', [_vm._v("DADOS DO VEÍCULO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-1",
      "href": "#hr1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-car"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" DADOS ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-2",
      "href": "#hr2"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-check-square-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" OPCIONAIS ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-3",
      "href": "#hr3"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-photo"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" MÍDIAS ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-4",
      "href": "#hr4"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-paperclip"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" ANEXOS ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-5",
      "href": "#hr5"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-list-ul"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" CHECKLIST ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-7",
      "href": "#hr7"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-sign-out"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" DESPESAS ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-8",
      "href": "#hr8"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-clock-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" HISTÓRICO ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-9",
      "href": "#hr9"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-copy"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" FINANCEIRO ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "jarviswidget-loader"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-567e9b09"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources/VehicleEntry/Create/CreatePage.vue
// module id = 1017
// module chunks = 1